import {Clickable} from 'platform/foundation';
import {match} from 'ts-pattern';

import {KeyboardEvent, ReactNode} from 'react';

import {isNotNil} from 'ramda-adjunct';

interface GalleryTileProps {
  label: string;
  isPressed?: boolean;
  onActivate: () => void;
  /** Arrow keys on the tile, e.g. to move the main photo. */
  onPrevious?: () => void;
  onNext?: () => void;
  children: ReactNode;
}

/** `Clickable` renders a div, so it gets the button role and the keyboard handling here. */
export function GalleryTile(props: GalleryTileProps) {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    const action = match(event.key)
      .returnType<(() => void) | undefined>()
      .with('Enter', ' ', () => props.onActivate)
      .with('ArrowLeft', () => props.onPrevious)
      .with('ArrowRight', () => props.onNext)
      .otherwise(() => undefined);

    if (isNotNil(action)) {
      event.preventDefault();
      action();
    }
  };

  return (
    <Clickable
      role="button"
      tabIndex={0}
      aria-label={props.label}
      aria-pressed={props.isPressed}
      onClick={props.onActivate}
      onKeyDown={handleKeyDown}
    >
      {props.children}
    </Clickable>
  );
}
